import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/CashBankMutationReport/CashBankMutationReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingCashBankMutationReportActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/CashBankMutationReport/CashBankMutationReport")
	}

	render() {
		return (
			<Activity 
				name="CashBankMutationReport"
				RenderedComponent={this.RenderedComponent}
				context="CashBankMutationReport"
				action="CashBankMutationReport"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingCashBankMutationReportActivity)
